import React from "react";
import styled from "styled-components";
import { SectionEyebrow, SectionTitle } from "../common/Section";
import releases from "../../../data/releases";

const sorted = [...releases].sort(
  (a, b) => b.streams - a.streams
);

const Section = styled.section`
  padding: clamp(4rem,6vw,5.5rem) 8vw;
  border-top: 1px solid var(--ink-06);
  @media (max-width: 480px) { padding-left: 5vw; padding-right: 5vw; }
`;

const Header = styled.div`margin-bottom: 32px;`;

const Marquee = styled.div`
  display: flex; flex-wrap: wrap; gap: 0;
  border-top: 1px solid var(--ink-10);
`;

const Item = styled.div`
  flex: 1 1 min(280px,100%);
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 18px; align-items: center;
  padding: 20px 0; border-bottom: 1px solid var(--ink-06);
  padding-right: 24px;
  @media (max-width: 768px) { grid-template-columns: 56px 1fr; gap: 14px; }
`;

const Thumb = styled.div`
  width: 72px; height: 72px; overflow: hidden;
  background: rgba(255,255,255,.03);
  border: 1px solid var(--ink-08);
  display: grid; place-items: center;
  img { width: 100%; height: 100%; object-fit: contain; padding: 4px; }
  @media (max-width: 768px) { width: 56px; height: 56px; }
`;

const Info = styled.div`
  h3 { font-size: 15px; letter-spacing: .06em; color: var(--ink); margin-bottom: 4px; }
  p { font-size: 12px; color: var(--muted); letter-spacing: .06em; }
`;

const HomeRoster: React.FC = () => (
  <Section>
    <Header>
      <SectionEyebrow>Artists &amp; collaborators</SectionEyebrow>
      <SectionTitle>Who we work with.</SectionTitle>
    </Header>
    <Marquee>
      {sorted.slice(0, 6).map((r) => (
        <Item key={r.id}>
          <Thumb><img src={r.image} alt={r.title} loading="lazy" /></Thumb>
          <Info>
            <h3>{r.artist || r.title}</h3>
            <p>{r.stat}</p>
          </Info>
        </Item>
      ))}
    </Marquee>
  </Section>
);

export default HomeRoster;
